import { Map, List, fromJS } from "immutable";
import groupBy from "lodash/groupBy";
import { combineReducers } from "redux";
import {
  ADD_TASK_DEPENDENCIES_LOADING,
  ADD_TASK_DEPENDENCIES_ERROR,
  DELETE_TASK_DEPENDENCIES_LOADING,
  DELETE_TASK_DEPENDENCIES_ERROR,
  DELETE_TASK_DEPENDENCIES_SUCCESS,
  FETCH_TASK_DEPENDENCIES_SUCCESS,
  FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS,
  MOVE_TASK_TO_TRASH_SUCCESS,
  ANGULAR_COPY_MOVE_TASK_TO_PROJECT,
  FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS,
  TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM,
} from "~/store/action_types";
import projectTasksDependencies from "./reducer.projectTasksDependencies.jsx";
import simulation from "./reducer.rescheduleSimulation.jsx";

const initialParentState = List();
const updateParents = (state = initialParentState, action) => {
  const parentId = parseInt(action.is_parent ? action.dependency_id : action.taskId);
  switch (action.type) {
    case DELETE_TASK_DEPENDENCIES_ERROR:
    case ADD_TASK_DEPENDENCIES_LOADING: {
      return state.push(parentId);
    }
    case ADD_TASK_DEPENDENCIES_ERROR:
    case DELETE_TASK_DEPENDENCIES_LOADING: {
      return state.filter((id) => id !== parentId);
    }
    case FETCH_TASK_DEPENDENCIES_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { parents = [] } = result;
      return List(parents);
    }
    default:
      return state;
  }
};

const initialParentsState = Map();
const parents = (state = initialParentsState, action) => {
  if (!action.type) return state;
  switch (action.type) {
    case DELETE_TASK_DEPENDENCIES_ERROR: {
      if (action.is_parent) {
        return state.set(`${action.taskId}`, updateParents(state.get(`${action.taskId}`, List()), action));
      }
      return state;
    }
    case ADD_TASK_DEPENDENCIES_LOADING: {
      const child = action.is_parent ? action.taskId : action.dependency_id;
      return state.set(`${child}`, updateParents(state.get(`${child}`), action));
    }
    case TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM: {
      const id = action.response.result;
      if (id) {
        return state.delete(`${id}`);
      }
      return state;
    }
    case ADD_TASK_DEPENDENCIES_ERROR:
    case DELETE_TASK_DEPENDENCIES_LOADING: {
      const child = action.is_parent ? action.taskId : action.dependency_id;
      const parentsList = updateParents(state.get(`${child}`), action);
      if (parentsList.size > 0) {
        return state.set(`${child}`, parentsList);
      }
      return state.delete(`${child}`);
    }
    case FETCH_TASK_DEPENDENCIES_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { children = [] } = result;

      let newState = state.set(`${action.taskId}`, updateParents(state.get(`${action.taskId}`), action));
      children.forEach((childId) => {
        let existingParentsList = newState.get(`${childId}`, List());
        if (existingParentsList.indexOf(action.taskId) === -1) {
          newState = newState.set(`${childId}`, existingParentsList.push(action.taskId));
        }
      });
      return newState;
    }
    case MOVE_TASK_TO_TRASH_SUCCESS: {
      const { id = 0 } = action;
      if (id) {
        state = state.delete(`${id}`);
      }
      return state;
    }
    case ANGULAR_COPY_MOVE_TASK_TO_PROJECT: {
      const { taskId } = action;
      return taskId ? state.delete(`${taskId}`) : state;
    }
    case FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS: {
      const { response = {} } = action;
      response.forEach((row) => {
        let prevList = state.get(`${row.child_id}`, List());
        if (prevList.indexOf(row.parent_id) === -1) {
          prevList = prevList.push(row.parent_id);
        }
        state = state.set(`${row.child_id}`, prevList);
      });
      return state;
    }
    default:
      return state;
  }
};

const initialChildState = List();
const updateChildren = (state = initialChildState, action) => {
  switch (action.type) {
    case DELETE_TASK_DEPENDENCIES_ERROR:
    case ADD_TASK_DEPENDENCIES_LOADING: {
      const child = action.is_parent ? action.taskId : action.dependency_id;
      return state.push(parseInt(child));
    }
    case ADD_TASK_DEPENDENCIES_ERROR:
    case DELETE_TASK_DEPENDENCIES_LOADING: {
      const child = action.is_parent ? action.taskId : action.dependency_id;
      return state.filter((id) => id !== parseInt(child));
    }
    case FETCH_TASK_DEPENDENCIES_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { children = [] } = result;
      return List(children);
    }
    default:
      return state;
  }
};

const initialChildrenState = Map();
const children = (state = initialChildrenState, action) => {
  if (!action.type) return state;
  switch (action.type) {
    case DELETE_TASK_DEPENDENCIES_ERROR: {
      if (!action.is_parent) {
        return state.set(`${action.taskId}`, updateChildren(state.get(`${action.taskId}`, List()), action));
      }
      return state;
    }
    case TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM: {
      const id = action.response.result;
      if (id) {
        return state.delete(`${id}`);
      }
      return state;
    }
    case ADD_TASK_DEPENDENCIES_LOADING: {
      const parent = action.is_parent ? action.dependency_id : action.taskId;
      return state.set(`${parent}`, updateChildren(state.get(`${parent}`), action));
    }
    case ADD_TASK_DEPENDENCIES_ERROR:
    case DELETE_TASK_DEPENDENCIES_LOADING: {
      const parent = action.is_parent ? action.dependency_id : action.taskId;
      const childrenList = updateChildren(state.get(`${parent}`), action);
      if (childrenList.size > 0) {
        return state.set(`${parent}`, childrenList);
      }
      return state.delete(`${parent}`);
    }
    case FETCH_TASK_DEPENDENCIES_SUCCESS:
      return state.set(`${action.taskId}`, updateChildren(state.get(`${action.taskId}`), action));
    case MOVE_TASK_TO_TRASH_SUCCESS: {
      const { id = 0 } = action;
      if (id) {
        state = state.delete(`${id}`);
      }
      return state;
    }
    case ANGULAR_COPY_MOVE_TASK_TO_PROJECT: {
      const { taskId } = action;
      return taskId ? state.delete(`${taskId}`) : state;
    }
    default:
      return state;
  }
};

const initialSuggestionState = List();
const updateSuggestion = (state = initialSuggestionState, action) => {
  switch (action.type) {
    case DELETE_TASK_DEPENDENCIES_SUCCESS:
    case ADD_TASK_DEPENDENCIES_ERROR:
      return state.push(action.dependency_id);
    case ADD_TASK_DEPENDENCIES_LOADING:
      return state.filter((id) => id !== action.dependency_id);
    case FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { tasks = [] } = result;
      return List(tasks);
    }
    default:
      return state;
  }
};

const initialSuggestionsState = Map();
const suggestions = (state = initialSuggestionsState, action) => {
  if (!action.type) return state;
  switch (action.type) {
    case DELETE_TASK_DEPENDENCIES_SUCCESS:
    case ADD_TASK_DEPENDENCIES_ERROR:
    case ADD_TASK_DEPENDENCIES_LOADING:
    case FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS:
      return state.set(`${action.taskId}`, updateSuggestion(state.get(`${action.taskId}`), action));
    case ANGULAR_COPY_MOVE_TASK_TO_PROJECT: {
      const { taskId } = action;
      return taskId ? state.delete(`${taskId}`) : state;
    }
    default:
      return state;
  }
};

const initialGroupedSuggestionState = Map();
const updateSuggestionsByTaskList = (state = initialGroupedSuggestionState, action) => {
  switch (action.type) {
    case ADD_TASK_DEPENDENCIES_ERROR: {
      const { taskListId, dependency_id } = action;
      state[taskListId] = state[taskListId] ? state[taskListId].push(dependency_id) : List([dependency_id]);
      return state;
    }
    case ADD_TASK_DEPENDENCIES_LOADING:
      state = state.map((tasks) => {
        // should remove selected task id from suggestions
        return tasks.filter((taskId) => taskId !== action.dependency_id);
      });

      return state.filter((tasks) => tasks.size);

    case FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { tasks = {} } = entities;

      let tasksGroupedByTaskListId = groupBy(tasks, `task_list_id`);

      Object.keys(tasksGroupedByTaskListId).forEach((taskListId) => {
        tasksGroupedByTaskListId[taskListId] = tasksGroupedByTaskListId[taskListId].map((task) => task.id);
      });

      return fromJS(tasksGroupedByTaskListId);
    }
    case ANGULAR_COPY_MOVE_TASK_TO_PROJECT: {
      return initialGroupedSuggestionState;
    }
    default:
      return state;
  }
};

// Task ids grouped by their task list id
const initialGroupedSuggestionsState = Map();
const groupedSuggestions = (state = initialGroupedSuggestionsState, action) => {
  if (!action.type) return state;
  switch (action.type) {
    case ADD_TASK_DEPENDENCIES_ERROR:
    case ADD_TASK_DEPENDENCIES_LOADING:
    case FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS:
    case ANGULAR_COPY_MOVE_TASK_TO_PROJECT:
      return state.set(`${action.taskId}`, updateSuggestionsByTaskList(state.get(`${action.taskId}`), action));
    default:
      return state;
  }
};

const initialRecentTasksState = Map();
const recentTasks = (state = initialRecentTasksState, action) => {
  if (!action.type) return state;
  switch (action.type) {
    case FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { recent_tasks = [] } = result;
      return state.set(`${action.taskId}`, List(recent_tasks));
    }
    default:
      return state;
  }
};

export default combineReducers({
  parents,
  children,
  suggestions,
  groupedSuggestions,
  recentTasks,
  simulation,
  projectTasksDependencies,
});
